import { render, staticRenderFns } from "./VotesList.vue?vue&type=template&id=0df7c94b&scoped=true&"
import script from "./VotesList.vue?vue&type=script&lang=js&"
export * from "./VotesList.vue?vue&type=script&lang=js&"
import style0 from "./VotesList.vue?vue&type=style&index=0&id=0df7c94b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df7c94b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
